import React, { useEffect, useRef, useState } from "react";
import AppBreadcrumb from "../../components/CustomeBreadcrumb/AppBreadcrumb";
import { Toast } from "primereact/toast";
import { getSpecificItemDetails } from "../../service/ProductService";
import { GET_DASHBOARD_DATA } from "../../config/ApiConstant";
import { Link } from "react-router-dom";
import { Skeleton } from "primereact/skeleton";
import { Chart } from "primereact/chart";
import { Messages } from "primereact/messages";
import { Calendar } from "primereact/calendar";
import UpdatePaymentMethod from "../../components/BankDetails/BankDetails";
import { Dialog } from "primereact/dialog";
import { convertDate } from "../../appconfig/AppHelper";
import { Badge } from "primereact/badge";

const ClientDashboard = () => {
  document.title = "Client Dashboard | Nexawage Payroll";
  const toast = useRef<any>(null);

  // message ref
  const msgs = useRef<any>(null);

  // dashboard data obj
  const [dashboardData, setDashboardData] = useState<any>();

  // page load obj
  const [pageLoad, setPageLoad] = useState<boolean>(false);

  // year obj
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState<Date | null>(new Date());

  // graph obj
  const [barOptions, setBarOptions] = useState<any>(null);
  const [barChartData, setBarChartData] = useState<any>(null);

  //  Modal state for first-time visit
  const [showBankModal, setShowBankModal] = useState(false);

  // stripe card detail form model
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  // holiday
  const [holidays, setHolidays] = useState<any>(null);
  const today = new Date();

  // get userData from local storage
  const rawUserData = localStorage.getItem("user_data");
  let userData: any = null;
  userData = rawUserData ? JSON.parse(rawUserData) : null;
  const userRole = userData?.roles?.role_name || "";

  //   useEffect to get dashboard data
  useEffect(() => {
    getDashboard();
  }, []);

  // bar chart
  useEffect(() => {
    prepareGrossPaymentChart(dashboardData, setBarChartData, setBarOptions);
  }, [dashboardData]);

  // display bar chart values
  const prepareGrossPaymentChart = (dashboardData: any, setBarChartData: (data: any) => void, setBarOptions: (options: any) => void) => {
    const payments = dashboardData?.gross_payment || [];
    if (payments.length > 0) {
      const values = payments.map((item: any) => parseFloat(item.gross_payment));

      // label format
      const labels = payments.map((item: any) => item.month);

      // bar chart data
      const dynamicBarData = {
        labels,
        datasets: [
          {
            label: "Gross Payment",
            backgroundColor: "rgb(54, 162, 235)",
            borderColor: "rgb(54, 162, 235)",
            data: values,
          },
        ],
      };

      // bar chart option
      const dynamicBarOptions = {
        maintainAspectRatio: false,
        aspectRatio: 0.6,
        responsive: true,
        plugins: {
          legend: {
            position: "top",
          },
          title: {
            display: true,
            text: "Gross Payments Over Time",
          },
          tooltip: {
            callbacks: {
              label: (ctx: any) => `$${ctx.raw?.toFixed(2) || 0}`,
            },
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              callback: (value: number) => `$${value}`,
            },
          },
          x: {
            ticks: {
              autoSkip: true,
              maxRotation: 45,
              minRotation: 0,
            },
          },
        },
      };

      setBarChartData(dynamicBarData);
      setBarOptions(dynamicBarOptions);
    } else {
      setBarChartData(null);
      setBarOptions(null);
    }
  };

  // get dashboard data
  const getDashboard = async (year = currentYear) => {
    try {
      const response = await getSpecificItemDetails(GET_DASHBOARD_DATA, "year", year);
      const data = response.data;

      if (data) {
        setDashboardData(data);
        setPageLoad(true);

        // set local storage with card detail added or not (flag)
        const payment_details_added = data?.payment_details_added;
        localStorage.setItem("payment_details_added", payment_details_added);
      } else {
        setDashboardData({});
        setPageLoad(false);
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message,
      });
      setPageLoad(false);
    }
  };

  // use Effect to display message to add bank details
  useEffect(() => {
    if (msgs.current) {
      msgs.current.show({
        sticky: true,
        severity: "info",
        summary: "Click here to add card details",
        detail: "",
        closable: false,
      });
    }
  }, []);

  // Check if user added bank detail or not
  useEffect(() => {
    if (!pageLoad) return;

    const model_status = localStorage.getItem("payment_model_status");

    // check if user has added bank details or not
    const bank_detail_added = dashboardData?.payment_details_added;

    // Show modal only if bank details NOT added
    if (model_status !== "true" && bank_detail_added !== true) {
      if (userRole === "User") {
        setShowBankModal(true);
      }
    }
  }, [dashboardData, pageLoad]);

  return (
    <>
      <AppBreadcrumb pageTitle="Dashboard" pageName="Dashboard" currentMenu="Client" />
      <Toast ref={toast} />
      <div className="layout-dashboard">
        <div className={`flex align-items-center justify-content-between`}>
          <div className="app-messages mb-0">
            {/* <Messages
              onClick={() => setShowPaymentModal(true)}
              className="mb-0"
              ref={msgs}
            /> */}

            {/* <div
              className="app-messages-info"
              onClick={() => setShowPaymentModal(true)}
            >
              <div
                className={`${
                  dashboardData?.payment_details_added === true
                    ? "message-info-card-added"
                    : "message-info-card-not-added"
                }`}
              >
                <span className="message-icon pi pi-info-circle" />
                <div className="message-content">
                  <span className="message-summary">
                    Click hear to add card details and enable access to all
                    features.
                  </span>
                </div>
              </div>
            </div> */}

            {/* {pageLoad && (
              <div
                className="app-messages-info"
                onClick={() => {
                  // Allow click only when user wants to add/update card
                  setShowPaymentModal(true);
                }}
              >
                <div
                  className={
                    dashboardData?.payment_details_added
                      ? "message-info-card-added"
                      : "message-info-card-not-added"
                  }
                >
                  <span
                    className={`message-icon pi ${
                      dashboardData?.payment_details_added
                        ? "pi-check-circle"
                        : "pi-exclamation-circle"
                    }`}
                  />

                  <div
                    className="message-content"
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <span className="message-summary font-semibold">
                      {dashboardData?.payment_details_added
                        ? "Card details are added"
                        : "Card details required"}
                    </span>

                    <p className="message-detail">
                      {dashboardData?.payment_details_added
                        ? "Your card is added and all features are enabled. You may add another card at any time."
                        : "To enable full access to payroll and billing features, please add your card details."}
                    </p>
                  </div>
                </div>
              </div>
            )} */}
          </div>

          <Calendar
            id="year"
            value={selectedYear}
            onChange={(e) => {
              if (e.value instanceof Date) {
                setSelectedYear(e.value);
              } else {
                setSelectedYear(null);
              }
            }}
            view="year"
            dateFormat="yy"
            showIcon
            className="w-auto"
            placeholder="Select Year"
          />
        </div>
        <div className="grid mt-2">
          {/* total employee */}
          <div className="col-12 md:col-6 lg:col-4">
            <Link to={"/employees"}>
              <div className="card dashbaord-main-box">
                <div className="small-box bg-info">
                  <div className="inner" style={{ borderLeft: "3px solid #0d6efd" }}>
                    <div className="flex flex-column justify-content-between">
                      <h2 className="mb-1 title-text">Total Employees</h2>
                      <div className="flex align-items-center justify-content-between">
                        <h3 className="mt-0 mb-0 num-text" style={{ color: "#0d6efd" }}>
                          {pageLoad ? (
                            !window.cn(dashboardData.client_employee_Count) ? (
                              dashboardData.client_employee_Count
                            ) : (
                              ""
                            )
                          ) : (
                            <Skeleton width="5rem" height="2.5rem" className="rounded" />
                          )}
                        </h3>
                        <div
                          className="dashboard-icon relative"
                          style={{
                            padding: "0.35rem",
                            backgroundColor: "#e7f0ff",
                            borderRadius: "9999px",
                            color: "#0d6efd",
                            width: "40px",
                            height: "40px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-user-check absolute"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              marginLeft: "3px",
                            }}
                            viewBox="0 0 24 24"
                          >
                            <path d="m17 12 2 2 4-4" />
                            <path d="M16 22v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2" />
                            <circle cx="10.5" cy="8" r="3" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>

          {/* total gross payment */}
          <div className="col-12 md:col-6 lg:col-4">
            <Link to={"/pd7a-report"}>
              <div className="card dashbaord-main-box">
                <div className="small-box bg-info">
                  <div className="inner" style={{ borderLeft: "3px solid #35b653" }}>
                    <div className="flex flex-column justify-content-between ">
                      <h2 className="mb-1 title-text">Total Gross Payment</h2>
                      <div className="flex align-items-center justify-content-between">
                        <h3 className="mt-0 mb-0 num-text" style={{ color: "#35b653" }}>
                          {pageLoad ? (
                            !window.cn(dashboardData.yearly_gross_payment) ? (
                              `$${dashboardData.yearly_gross_payment}`
                            ) : (
                              ""
                            )
                          ) : (
                            <Skeleton width="5rem" height="2.5rem" className="rounded" />
                          )}
                        </h3>
                        <div
                          className="dashboard-icon"
                          style={{
                            padding: "0.35rem",
                            backgroundColor: "#e8fff2",
                            borderRadius: "9999px",
                            color: "#35b653",
                            width: "40px",
                            height: "40px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            className="lucide lucide-dollar-sign-circle"
                          >
                            <circle cx="12" cy="12" r="10" />
                            <path d="M12 6v12" />
                            <path d="M16 8H10a2 2 0 0 0 0 4h4a2 2 0 0 1 0 4H8" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>

          {/* total tax */}
          <div className="col-12 md:col-6 lg:col-4">
            <Link to={"/pd7a-report"}>
              <div className="card dashbaord-main-box">
                <div className="small-box bg-info">
                  <div className="inner" style={{ borderLeft: "3px solid #dc3545" }}>
                    <div className="flex flex-column justify-content-between">
                      <h2 className="mb-1 title-text">Total Tax</h2>
                      <div className="flex align-items-center justify-content-between">
                        <h3 className="mt-0 mb-0 num-text" style={{ color: "#dc3545" }}>
                          {pageLoad ? (
                            !window.cn(dashboardData.yearly_total_tax) ? (
                              `$${dashboardData.yearly_total_tax}`
                            ) : (
                              ""
                            )
                          ) : (
                            <Skeleton width="5rem" height="2.5rem" className="rounded" />
                          )}
                        </h3>
                        <div
                          className="dashboard-icon"
                          style={{
                            padding: "0.35rem",
                            backgroundColor: "#ffe8ea",
                            borderRadius: "9999px",
                            color: "#dc3545",
                            width: "40px",
                            height: "40px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="22"
                            height="22"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-dollar-sign-circle"
                          >
                            <circle cx="12" cy="12" r="9" />
                            <path d="M12 6v12" />
                            <path d="M16 8H10a2 2 0 0 0 0 4h4a2 2 0 0 1 0 4H8" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>

          {/* current month gross */}
          {/* <div className="col-12 md:col-6 lg:col-3">
            <div className="card dashbaord-main-box">
              <div className="small-box bg-info">
                <div
                  className="inner"
                  style={{ borderLeft: "3px solid rgb(33 201 210)" }}
                >
                  <div className="flex flex-column justify-content-between">
                    <h2 className="mb-1 title-text">
                      Current Month Gorss Payment
                    </h2>
                    <div className="flex align-items-center justify-content-between">
                      <h3
                        className="mt-0 mb-0 num-text"
                        style={{ color: "rgb(33 201 210)" }}
                      >
                        {pageLoad ? (
                          !window.cn(dashboardData) ? (
                            userRole === "Client" &&
                            !window.cn(dashboardData.client_employee_Count) ? (
                              dashboardData.client_employee_Count
                            ) : userRole === "Admin" &&
                              !window.cn(dashboardData.emp_count) ? (
                              dashboardData.emp_count
                            ) : (
                              ""
                            )
                          ) : (
                            ""
                          )
                        ) : (
                          <Skeleton
                            width="5rem"
                            height="2.5rem"
                            className="rounded"
                          />
                        )}
                      </h3>
                      <div
                        className="dashboard-icon"
                        style={{
                          padding: "0.35rem",
                          backgroundColor: "rgb(230 246 247)",
                          borderRadius: "9999px",
                          color: "rgb(33 201 210)",
                          width: "40px",
                          height: "40px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          className="lucide lucide-dollar-sign-circle"
                        >
                          <circle cx="12" cy="12" r="10" />
                          <path d="M12 6v12" />
                          <path d="M16 8H10a2 2 0 0 0 0 4h4a2 2 0 0 1 0 4H8" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </div>

        {/* if userrole is client or employee then bar graph will visible */}
        <div className="grid">
          <div className="col-12">
            <div className="card bar-chart-wrapper">
              <div className="flex justify-content-between align-items-center">
                <h5 className="m-0">Gross Payment</h5>
              </div>

              {pageLoad ? (
                barChartData ? (
                  <Chart type="line" data={barChartData} options={barOptions} />
                ) : (
                  <div className="flex gap-1 p-4 align-items-center flex-column justify-content-center ">
                    <img
                      src="https://res.cloudinary.com/dpc2muwar/image/upload/v1753697918/no-datas_voktda.png"
                      alt=""
                      width="120"
                      height="120"
                      style={{ marginBottom: "-8px" }}
                    />
                    <p className="text-gray-500">No Gross Payment data available for the selected year.</p>
                  </div>
                )
              ) : (
                <Skeleton height="300px" className="mt-3 mb-3 border-round" />
              )}
            </div>
          </div>

          {/* <div className="col-12 md:col-12 p-0 flex">
            <div className="col-12 md:col-9">
              <div className="card widget-revenue-graph mb-0">
                <div className="card-header mb-1">
                  <span className="overview-text-h">Gross Payment</span>
                  <Calendar
                    id="year"
                    value={selectedYear}
                    onChange={(e) => {
                      if (e.value instanceof Date) {
                        setSelectedYear(e.value);
                      } else {
                        setSelectedYear(null);
                      }
                    }}
                    view="year"
                    dateFormat="yy"
                    showIcon
                    className="w-auto"
                    placeholder="Select Year"
                  />
                </div>

                <div className="graph">
                  {pageLoad ? (
                    barChartData ? (
                      <Chart
                        type="line"
                        id="gross-chart"
                        data={barChartData}
                        options={barOptions}
                        style={{ maxHeight: "50vh" }}
                      ></Chart>
                    ) : (
                      <div className="flex gap-1 p-4 align-items-center flex-column justify-content-center ">
                        <img
                          src="https://res.cloudinary.com/dpc2muwar/image/upload/v1753697918/no-datas_voktda.png"
                          alt=""
                          width="120"
                          height="120"
                          style={{ marginBottom: "-8px" }}
                        />
                        <p className="text-gray-500">
                          No Gross Payment data available for the selected year.
                        </p>
                      </div>
                    )
                  ) : (
                    <Skeleton
                      height="300px"
                      className="mt-3 mb-3 border-round"
                    />
                  )}
                </div>
              </div>
            </div>

            <div className="col-12 md:col-3 new-overview-boxes">
              <div className="card widget-overview-box widget-overview-box-1">
                {!window.cn(holidays) && !window.cn(holidays?.today) && (
                  <>
                    <span className="overview-title">Holidays</span>
                    <div className="overview-details mt-2">
                      <div className="overview-text-h">
                        Today is {holidays?.today?.festival}{" "}
                      </div>
                    </div>
                  </>
                )}
                <div className="overview-details mt-2">
                  <div className="overview-text-h upcoming-holidays mb-2">
                    Upcoming Holidays
                  </div>
                  {!window.cn(holidays) && !window.cn(holidays?.upcoming) ? (
                    <div className="grid">
                      {holidays?.upcoming.length > 0 &&
                        holidays?.upcoming.map((item: any, index: any) => (
                          <div
                            className={`col-12 md:col-6 pb-0 ${
                              index % 2 === 0 ? "" : "justify-content-end"
                            }`}
                            key={index}
                          >
                            <div className="holiday-name">{item?.festival}</div>
                            <div className="holidaye-date text-end">
                              {convertDate(item?.date)}
                            </div>
                          </div>
                        ))}
                    </div>
                  ) : (
                    <span>No Upcomming Holiday Found..!!</span>
                  )}
                </div>
              </div>

              <div className="card widget-overview-box widget-overview-box-1 dashboard-payment-status">
                <span className="overview-text-h overview-title">
                  Payment Status For Current Cycle
                </span>
                <div className="overview-details">
                  <div>
                    <Badge
                      severity="success"
                      value={"Completed"}
                      style={{ width: "fit-content" }}
                    />
                  </div>
                  {`Last Payment Done On: ${convertDate(today)}`}
                </div>
              </div>

              <div className="card widget-overview-box widget-overview-box-1 dashboard-payment-status">
                <span className="overview-text-h overview-title">
                  Employee Remaining To Generate Paystub For Current Cycle
                </span>
                <div className="overview-details">hardik, alpesh...</div>
              </div>
            </div>
          </div> */}
        </div>
      </div>

      {/* add bank details model */}
      <Dialog
        header="Add Card Details"
        visible={showBankModal}
        onHide={() => {
          setShowBankModal(false);
          localStorage.setItem("payment_model_status", "true");
        }}
        modal
        draggable={false}
        dismissableMask={false}
        className="bank-details-modal mx-3 lg:mx-0"
        style={{ width: "30rem" }}
        footer={<div></div>}
      >
        <p className="m-0 text-center">It looks like you haven't added your card details yet.</p>

        <div className="flex justify-content-center mt-4">
          <button
            className="bank-modal-btn"
            onClick={() => {
              setShowBankModal(false);
              setShowPaymentModal(true);
              localStorage.setItem("payment_model_status", "true");
            }}
          >
            Add Card Details
          </button>
        </div>
      </Dialog>

      {/* dialog for stripe card detail form */}
      <Dialog
        header="Add Card Details"
        visible={showPaymentModal}
        onHide={() => setShowPaymentModal(false)}
        modal
        draggable={false}
        dismissableMask={false}
        className="mx-3 lg:mx-0"
        style={{ width: "35rem" }}
        footer={<div></div>}
      >
        <UpdatePaymentMethod customerId={userData?.customer_id} onSuccess={() => setShowPaymentModal(false)} getApiCall={() => getDashboard()} />
      </Dialog>
    </>
  );
};

export default ClientDashboard;
